// Single source of truth for all contact info shown on the site.
// If any of these values change, update them here — every page reads from this file.

export const CONTACT = {
  phone: "8976773152",
  phoneDisplay: "+91 89767 73152",
  email: "info@theebg.com",
  address:
    "Knowledge City, 12th Floor, Dallas Center, Hitech City Main Rd, Silpa Gram Craft Village, Madhapur, Rai Durg, Hyderabad, Telangana 500032",
  whatsapp: (message = "Hi eBikeGo team, I'd like to enquire about renting an EV.") =>
    `https://wa.me/918976773152?text=${encodeURIComponent(message)}`,
};
